import { createStrictContext } from 'utils/createContext'
import { AsphaltMixDesignsContext } from './types'
import {
  useAsphaltMixDesignsMetadataQuery,
  useAsphaltMixDesignsQuery,
  useEditAsphaltMixDesignMutation,
} from 'schema'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { useGlobalState } from 'context/GlobalStateContext'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useCIMSModalValues } from 'components/CIMSModal/hooks/useCIMSModal'

const { Provider, useContextFn } =
  createStrictContext<AsphaltMixDesignsContext>('AsphaltMixDesignsContext')

export const useAsphaltMixDesignsContext = useContextFn

const AsphaltMixDesignsProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const options = {
    ...DefaultQueryHookOptions,
    variables: { projectId: projectId! },
    skip: !projectId,
  }
  const { data, loading, refetch } = useAsphaltMixDesignsQuery(options)
  const { data: metadataData, ...metadata } =
    useAsphaltMixDesignsMetadataQuery(options)
  const [edit] = useEditAsphaltMixDesignMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editAsphaltMixDesign: {
        mixDesign: { mixDesignNumber, globalId },
      },
    }) => simpleEditNotification(mixDesignNumber ?? globalId),
  })
  return (
    <Provider
      value={{
        loading,
        refetch,
        mixDesigns: data?.asphaltMixDesigns?.records ?? [],
        edit,
        createModal: useCIMSModalValues(),
        metadata: {
          targets: metadataData?.limsAsphaltMixDesignTargets?.records ?? [],
          materialSources: metadataData?.asphaltMaterialSources?.records ?? [],
          ...metadata,
        },
      }}
    >
      {children}
    </Provider>
  )
}

export default AsphaltMixDesignsProvider
